
<div class="drawer-container">
    <div
        [@iccDrawerAnimation]="drawerAnimationState"
        class="drawer"
        #drawer
    >
        <icc-complaint-filters
            [filters]="filters"
            (filtersEmitter)="setFilters($event)"
            [workersList]="workersList"
            [contractorsList]="contractorsList"
            [documentStatuses]="documentStatuses"
            [showDocumentStatuses]="showDocumentStatuses"
            [userType]="getUserType()"
            (showMap)="onShowMap($event)"
            [isShowMap]="showMap"
        ></icc-complaint-filters>

    </div>
    <div class="container" *ngIf="!showMap">
        <div class="actions">
            <div class="actions-left">
                <button
                    iccButton
                    appearance="secondary"
                    (click)="changeDrawerAnimationState()"
                    *ngIf="mobileView"
                    #drawerButton
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Filtruj' | translate }}
                </button>
            </div>
            <div class="actions-right" *ngIf="showDebugSection">
                <span class="action-link-offline" (click)="switchOfflineMode(false)" [class.active]="!offline">{{ 'COMPLAINT|Lista dokumentów online' | translate}}</span>
                <span class="action-link-offline" (click)="switchOfflineMode(true)" [class.active]="offline">{{ 'COMPLAINT|Lista dokumentów offline' | translate}}</span>
                <button class="action-button-refresh" iccIconButton appearance="flat-base" (click)="updateDocuments(true)" [title]="'INTERFACE|Odśwież' | translate">
                    <icc-icon name="replay"></icc-icon>
                </button>
            </div>
        </div>
        <icc-complaint-list-table
            [filteredDocuments]="filteredDocuments"
            [orderedDocuments]="orderedDocuments"
            [documentStatuses]="documentStatuses"
            [mode]="mode"
            [columnSortOptions]="columnSortOptions"
            [documentsInPage]="documentsInPage"
            [totalItems]="totalItems"
            [page]="page"
            [userType]="getUserType()"
            [viewComplaintOrderNumber]="hasAccessTo.viewComplaintOrderNumber"
            (updateDocuments)="onUpdateDocuments($event)"
            (saveConfiguration)="onSaveConfiguration()"
            (changeOrderBy)="onChangeOrderBy($event)"
            (currentPageEmitter)="onCurrentPageEmitter($event)"
        ></icc-complaint-list-table>
    </div>

    <div class="map-container" *ngIf="showMap">
        <div class="actions">
            <div class="actions-left">
                <button
                    [style.margin-bottom.px]="showMap ? 8 : 0"
                    iccButton
                    appearance="secondary"
                    (click)="changeDrawerAnimationState()"
                    *ngIf="mobileView"
                    #drawerButton
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Filtruj' | translate }}
                </button>
            </div>
        </div>
        <icc-complaint-map
            [filteredDocuments]="filteredDocuments"
            [resetMapZoomAndCenter]="resetMapZoomAndCenter"
        ></icc-complaint-map>
    </div>
</div>
